// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__AqoDk","title":"card_title__3AKX5","inActive":"card_inActive__2qV8X"};